module.exports = __webpack_public_path__ + "img/Infografis_EN_07.8689202f.jpg";